import { CsatReport } from './CsatReport'
import type { CsatPanel } from '@/types/analytics'

// Static mock data feeding the real CsatReport, so the design space previews the
// actual CSAT analytics layout used in the Analytics → CSAT tab.
const MOCK: CsatPanel = {
  average: 4.3,
  response_count: 128,
  request_count: 210,
  response_rate: 0.61,
  positive_rate: 0.82,
  trend: Array.from({ length: 14 }, (_, i) => ({
    date: `2026-06-${String(i + 1).padStart(2, '0')}`,
    average: 4 + Math.sin(i / 2) * 0.6,
    count: 6 + (i % 4),
  })),
  distribution: [
    { rating: 1, count: 4 },
    { rating: 2, count: 6 },
    { rating: 3, count: 13 },
    { rating: 4, count: 31 },
    { rating: 5, count: 74 },
  ],
  by_agent: [
    { name: 'Sarah Okafor', average: 4.7, count: 41 },
    { name: 'Marcus Roth', average: 4.4, count: 38 },
    { name: 'Priya Nair', average: 4.1, count: 29 },
    { name: 'Dan Whitfield', average: 3.6, count: 20 },
  ],
  recent_comments: [
    { name: 'Adam Healy', rating: 5, comment: 'Super fast and friendly — sorted in minutes.', responded_at: '2026-06-14T10:00:00Z' },
    { name: 'Lena Voss', rating: 4, comment: 'Helpful, though I had to repeat my issue once.', responded_at: '2026-06-13T09:00:00Z' },
    { name: 'Tomás Río', rating: 2, comment: 'Took a while to get a real answer.', responded_at: '2026-06-12T08:00:00Z' },
  ],
}

export function CsatAnalyticsDemo() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold">CSAT analytics</h2>
        <p className="text-sm text-muted-foreground">
          Live layout (Analytics → CSAT), shown here with static sample data.
        </p>
      </div>
      <CsatReport data={MOCK} />
    </div>
  )
}

export default CsatAnalyticsDemo
